import React, { memo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import fontService, { FontWeight, TextType } from 'services/FontService';
import { Colors } from 'context';
// `config/*` не заведён в tsconfig paths — импортируем относительным путём, как
// это уже делает `useLessonTabs` для `courseIframeConfig`.
import { GroupServiceInfo as IGroupService } from '../../../config/groupOverrides';

export interface IGroupServiceInfo {
  /** Реквизиты услуги; `null` для обычных групп — тогда блок не рендерится. */
  service?: IGroupService | null;
  className?: string;
}

/**
 * Реквизиты услуги (BUR / дофинансирование) для отдельных групп: номер услуги и
 * срок её действия. Показываются всем ролям — это реквизит договора, а не
 * персональные данные.
 *
 * Срок услуги живёт рядом с «занятия без дат» осознанно: это статичный реквизит
 * на всю группу, он не говорит, какое занятие когда, и расписание не выдаёт.
 */
export const GroupServiceInfo = memo(({ service, className }: IGroupServiceInfo) => {
  const { t } = useTranslation();

  if (!service) {
    return null;
  }

  return (
    <Wrapper className={className}>
      <Row>
        <Label>{t('groupService.number')}</Label>
        <Value>{service.serviceNumber}</Value>
      </Row>
      <Row>
        <Label>{t('groupService.period')}</Label>
        <Value>
          {t('groupService.periodValue', { from: service.periodFrom, to: service.periodTo })}
        </Value>
      </Row>
    </Wrapper>
  );
});

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  z-index: 2;
`;

const Row = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.span`
  ${fontService.text({ type: TextType.extraSmall })};
  color: ${Colors.gray_dark};
`;

const Value = styled.span`
  ${fontService.text({ type: TextType.normal, weight: FontWeight.medium })};
  word-break: break-word;
`;
